(() => {
  // One paid wrapping unit for each product unit explicitly marked "Evet".
  const variantId = Number(window.renaoGiftWrapVariantId || 0);
  const marker = '_Hediye paketi seçimi';
  const choice = 'Yes, add gift wrapping';
  let queue = Promise.resolve();
  const request = async (url, body) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
    const response = await fetch(url, {
      credentials: 'same-origin', signal: controller.signal,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}),
    });
    const data = await response.json();
    if (!response.ok || data.errors || data.status) throw new Error('Could not update gift wrapping. Check your cart and try again.');
    return data;
    } finally { clearTimeout(timeout); }
  };
  const reconcile = async (sections = {}) => {
    const cartUrl = window.routes?.cart_url || '/cart';
    let cart = await request(`${cartUrl}.js`);
    const managed = cart.items.filter(item => Number(item.variant_id) === variantId && item.properties?.[marker]);
    const wanted = cart.items.reduce((sum, item) => sum + (
      Number(item.variant_id) !== variantId && /^(yes|evet)\b/i.test(String(item.properties?.['Hediye Paketi'] || '').trim()) ? Number(item.quantity) : 0
    ), 0);
    let changed = false;
    if (managed.length) {
      const updates = {};
      managed.forEach((item, index) => {
        const quantity = index === 0 ? wanted : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) {
        cart = await request(window.routes?.cart_update_url || '/cart/update.js', { updates, ...sections });
        changed = true;
      }
    } else if (wanted) {
      await request(`${cartUrl}/add.js`, { items: [{ id: variantId, quantity: wanted, properties: { [marker]: choice } }] });
      cart = await request(`${cartUrl}.js`);
      changed = true;
    }
    return { cart, changed };
  };
  window.RenaoGiftWrap = {
    sync(sections) {
      const next = queue.catch(() => {}).then(() => reconcile(sections));
      queue = next;
      return next;
    },
  };
})();
